<template>
  <p>صفحة المحاسب</p>
</template>
